import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { sendCode, sendCodeForPromissory } from 'services/auth'
interface ISendCodePayload {
    phone_number: string
}
const UseSendCodeForPromissory = () => {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISendCodePayload) => {
            return sendCodeForPromissory(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('کد با موفقیت ارسال شد')
        },
        onError: () => {
            toast.error('خطایی رخ داده!')
        },
    })
    return { isLoading, mutate }
}

export default UseSendCodeForPromissory
